import { Stack } from '@mui/material'
import { tokens, Typography } from 'ComponentLibrary'

export type ValueRow = { label: string; value?: string | null }

type ValueRowsProps = {
    rows: ValueRow[]
}

export const ValueRows = ({ rows }: ValueRowsProps) => {
    return (
        <Stack direction="column" gap={tokens.SizingSpacing075}>
            {rows.map(({ label, value }) => (
                <Stack direction="row" key={label} justifyContent="space-between">
                    <Typography variant="bodyTextMedium" color={tokens.ColorTextSubtle}>
                        {label}
                    </Typography>
                    <Typography variant="bodyTextMedium">{value || '-'}</Typography>
                </Stack>
            ))}
        </Stack>
    )
}
